export const CATEGORY_COLORS = {
  FAO: {
    badgeBackground: "#10B981",
    borderColor: "#10B981",
    textColor: "#065F46",
  },
  ORGANIZACIÓN: {
    badgeBackground: "#3B82F6",
    borderColor: "#3B82F6",
    textColor: "#1E40AF",
  },
  "POR ASIGNAR": {
    badgeBackground: "#F59E0B",
    borderColor: "#F59E0B",
    textColor: "#92400E",
  },
} as const;


export const STAT_COLORS = {
  departamentos: "bg-indigo-500",
  municipios: "bg-indigo-600",
  subregiones: "bg-indigo-700",
} as const
